if (!customElements.get('hover-card')) {
  customElements.define('hover-card', class HoverCard extends HTMLElement {
    constructor() {
      super();

      // elements
      this.button = this.querySelector('.hover-card-button')
      this.buttonPing = this.querySelector('.hover-card-button-ping')
      this.card = this.querySelector('.hover-card')
      this.isOpen = false

      // transition in
      this.classClose = ['tw-transition','tw-ease-in','tw-transform,','tw-opacity-0','tw-translate-y-4','tw-scale-0', 'tw-z-0', 'sp-invisible']
      this.classOpen = ['tw-transition','tw-ease-out','tw-transform,','tw-opacity-100','tw-translate-y-0','tw-scale-100', 'tw-z-2']
      this.card.classList.add(...this.classClose)

      // function bindings
      this.open = this.open.bind(this)
      this.close = this.close.bind(this)
      this.onButtonClick = this.handleButtonClick.bind(this)
      this.onBodyClick = this.handleBodyClick.bind(this)

      // listeners
      this.card.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
      this.button.addEventListener('click', this.onButtonClick)
    }

    open() {
      document.querySelectorAll('hover-card').forEach(hc => {
        if (hc !== this && hc.isOpen) hc.close()
      })
      
      this.isOpen = true
      this.buttonPing.classList.add('tw-hidden')
      this.card.classList.remove(...this.classClose,'tw-invisible')      
      this.card.classList.add(...this.classOpen)
      
      this.classList.add('tw-z-20')
      document.body.addEventListener('click', this.onBodyClick);
    }
  

    close() {
      if (!this.isOpen) return
      this.isOpen = false

      this.buttonPing.classList.remove('tw-hidden')
      this.card.classList.remove(...this.classOpen)
      this.card.classList.add(...this.classClose)
      this.classList.remove('tw-z-20')

      this.card.addEventListener('transitionend', () => {
        this.card.classList.add('tw-invisible')
      },{ once: true })
  
      document.body.removeEventListener('click', this.onBodyClick);
    }

    handleButtonClick(evt) {
      evt.preventDefault()
      evt.stopPropagation()

      if (this.isOpen) {
        this.close()
      } else {
        this.open()
      }
    }

    handleBodyClick(evt) {
      if (!this.contains(evt.target)) {
        this.close();
      }
    }
  })
}
